<template>
  <div class="new-footer">
    <div class="wrapper" style="margin-top:0;padding-left:88px;">
      <div>
        <img src="../assets/images/logo_white.png" alt width="138"/>
      </div>
      <div class="service">
        <img src="../assets/icons/footer_icon1.png" alt="">
        <div class="fl">
          <p>在线客服</p>
          <p class="fs-16">7*24小时人工在线</p>
        </div>
      </div>
      <div class="service"  >
        <img src="../assets/icons/footer_icon2.png" alt="">
        <div class="fl">
          <p>咨询热线</p>
          <p class="fs-16">400-111-5318<span class="fs-14">（工作日 9:00-18:00）</span></p>
        </div>
      </div>
      <div style="margin-left:100px;">Copyright &copy; 2019三一集团 版权所有 湘ICP备10005672号-3</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    
  }
}
</script>

<style lang="less">
@import '../styles/common.less';
.new-footer {
  width: 100%;
  background: #2a2a2a;
  height: 100px;
  box-sizing: border-box;
  color: #fff; 
  &>div {
    height: 100%;
    line-height: 100px;
    &>div {
      float: left;
    }
    .service {
      line-height: normal;
      margin-top: 28px;
      margin-left: 70px;
      img {
        float: left;
        position: relative;
        top: 12px;
        margin-right: 12px;
      }
      p {
        margin-bottom: 6px;
      }
    }
  }
}

</style>
